/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccommodationRequestPayload,
  AccommodationRequestResponse,
  AttachPersonaInquiryPayload,
  AttachPersonaInquiryResponse,
  AudioRecordingCheckResponse,
  BodyCallCreateOrFindExistingCandidateCall,
  BodyCallFinalizeWebCallRecording,
  BodyCallGetAndCreateTestCallCandidateInfo,
  BodyCallSubmitVerifiedInterviewDraft,
  CallCompletionStatusResponse,
  CallCreatedResponse,
  CallExtractFramesFromCheatingEventsParams,
  CallGetCampaignLinksParams,
  CallGetCampaignSettingsForWebCallParams,
  CameraRestoredResponse,
  CampaignLinkRequest,
  CancelPersonaVerificationPayload,
  CancelPersonaVerificationResponse,
  CandidateCapabilityRequest,
  CandidateCapabilityResponse,
  CandidateWebCallPayload,
  CandidateWebCallResponse,
  CaptureFramePayload,
  CaptureFrameResponse,
  CheckWebLinkResponse,
  CompleteInterviewDraftRequest,
  CreateInterviewDraftRequest,
  DeletedLinkNewInterviewRequestPayload,
  DeletedLinkNewInterviewRequestResponse,
  ExtractFramesResponse,
  FinalizeRecordingResponse,
  GenerateCampaignLinkResponse,
  GeneratePreapplyOptOutLinkResponse,
  GetFaceMatchSessionsResponse,
  GetNetworkHistoryResponse,
  GetPersonaVerificationsResponse,
  InitialEmailTestPayload,
  InitiateCallPayload,
  InitiatePersonaVerificationPayload,
  InitiatePersonaVerificationResponse,
  InitiateTestWebCallPayload,
  InternalInitiateCallResponse,
  InterviewDraftResponse,
  InterviewLaunchExchangeRequest,
  InterviewLaunchResponse,
  InterviewSessionBootstrap,
  InterviewSessionRefreshRequest,
  InterviewSessionResponse,
  LogCheatingEventPayload,
  LogCheatingEventResponse,
  MultipleDisplaysRemovedResponse,
  OptOutOfActiveCallResponse,
  OptOutRequestPayload,
  OptOutRequestResponse,
  PersonaInquiryExpiredResponse,
  PersonaVerificationStatusResponse,
  PersonaVerificationTemplateResponse,
  PracticeInterviewUrlPayload,
  PracticeInterviewUrlResponse,
  PreapplyOptOutPageDataResponse,
  PreapplyOptOutPayload,
  PreflightTokenResponse,
  ProceedPartialVerificationPayload,
  ProceedPartialVerificationResponse,
  ReportMediaDevicesPayload,
  ReportMediaDevicesResponse,
  SaveNetworkHistoryPayload,
  SaveNetworkHistoryResponse,
  ScreenShareRestoredResponse,
  SendEmailInvitePayload,
  SendTestInitialEmailResponse,
  SendWebCallTestEmailResponse,
  SendWebInviteEmailResponse,
  SimulateIntakeSmsResponse,
  SimulateSMSPayload,
  StaffTestSessionPayload,
  SubmitPreapplyOptOutResponse,
  SubmitVerifiedInterviewDraftResponse,
  TestCallPayload,
  TestCallResponse,
  TestCallResultsResponse,
  UnredactedTranscriptResponse,
  UpdatePersonaVerificationStatusPayload,
  UpdatePersonaVerificationStatusResponse,
  UpdateVerificationExplanationResponse,
  ValidateEncodedIdResponse,
  VerifyInterviewContactResponse,
  VerifyPersonaIdentityPayload,
  VerifyPersonaIdentityResponse,
  VerifyPersonaWithExplanationPayload,
  WebAgentDispatchResponse,
  WebCallEmailPayload,
  WebCallFunnelEventPayload,
  WebCallFunnelEventResponse,
  WebCallInitiatedResponse,
  WebCallLanguagePreferencePayload,
  WebCallLanguagePreferenceResponse,
  WebCallSettingsResponse,
  WebInterviewErrorAlertPayload,
  WebInterviewErrorAlertResponse,
  WebRecordingCheckResponse,
} from '../types';

import { axiosInstance } from '../../axiosConfig';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getCall = () => {
  /**
 * Create a candidate call from a shared link with optional resume upload.
This endpoint processes candidate information including an optional resume file.
The resume is processed to extract text content and stored for later use.

The existing persisted session remains authoritative after submission.
 * @summary Create Or Find Existing Candidate Call
 */
  const callCreateOrFindExistingCandidateCall = (
    bodyCallCreateOrFindExistingCandidateCall: BodyCallCreateOrFindExistingCandidateCall,
    options?: SecondParameter<typeof axiosInstance<CallCreatedResponse>>
  ) => {
    const formData = new FormData();
    formData.append(
      `first_name`,
      bodyCallCreateOrFindExistingCandidateCall.first_name
    );
    formData.append(
      `campaign_id`,
      bodyCallCreateOrFindExistingCandidateCall.campaign_id
    );
    if (
      bodyCallCreateOrFindExistingCandidateCall.email !== undefined &&
      bodyCallCreateOrFindExistingCandidateCall.email !== null
    ) {
      formData.append(`email`, bodyCallCreateOrFindExistingCandidateCall.email);
    }
    if (
      bodyCallCreateOrFindExistingCandidateCall.phone !== undefined &&
      bodyCallCreateOrFindExistingCandidateCall.phone !== null
    ) {
      formData.append(`phone`, bodyCallCreateOrFindExistingCandidateCall.phone);
    }
    if (bodyCallCreateOrFindExistingCandidateCall.last_name !== undefined) {
      formData.append(
        `last_name`,
        bodyCallCreateOrFindExistingCandidateCall.last_name
      );
    }
    if (bodyCallCreateOrFindExistingCandidateCall.questions !== undefined) {
      formData.append(
        `questions`,
        bodyCallCreateOrFindExistingCandidateCall.questions
      );
    }
    if (
      bodyCallCreateOrFindExistingCandidateCall.resume_file !== undefined &&
      bodyCallCreateOrFindExistingCandidateCall.resume_file !== null
    ) {
      formData.append(
        `resume_file`,
        bodyCallCreateOrFindExistingCandidateCall.resume_file
      );
    }
    if (
      bodyCallCreateOrFindExistingCandidateCall.opt_out_of_ai_pre_screen !==
      undefined
    ) {
      formData.append(
        `opt_out_of_ai_pre_screen`,
        bodyCallCreateOrFindExistingCandidateCall.opt_out_of_ai_pre_screen.toString()
      );
    }
    if (bodyCallCreateOrFindExistingCandidateCall.force_rejoin !== undefined) {
      formData.append(
        `force_rejoin`,
        bodyCallCreateOrFindExistingCandidateCall.force_rejoin.toString()
      );
    }
    if (
      bodyCallCreateOrFindExistingCandidateCall.encoded_id !== undefined &&
      bodyCallCreateOrFindExistingCandidateCall.encoded_id !== null
    ) {
      formData.append(
        `encoded_id`,
        bodyCallCreateOrFindExistingCandidateCall.encoded_id
      );
    }
    if (
      bodyCallCreateOrFindExistingCandidateCall.web_call_encoded_id !==
        undefined &&
      bodyCallCreateOrFindExistingCandidateCall.web_call_encoded_id !== null
    ) {
      formData.append(
        `web_call_encoded_id`,
        bodyCallCreateOrFindExistingCandidateCall.web_call_encoded_id
      );
    }

    return axiosInstance<CallCreatedResponse>(
      {
        url: `/create_or_find_existing_candidate_call`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
      },
      options
    );
  };
  /**
   * Initiate call endpoint to allow other servers (queue_server) to start calls.
   * @summary Internal Initiate Call
   */
  const callInternalInitiateCall = (
    initiateCallPayload: InitiateCallPayload,
    options?: SecondParameter<
      typeof axiosInstance<InternalInitiateCallResponse>
    >
  ) => {
    return axiosInstance<InternalInitiateCallResponse>(
      {
        url: `/internal/initiate_call`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: initiateCallPayload,
      },
      options
    );
  };
  /**
 * Universal web call initiation endpoint for individual and shared links.

Retry calls are enrolled into the same persisted grant before media/control credentials are issued.
 * @summary Candidate Web Call
 */
  const callCandidateWebCall = (
    candidateWebCallPayload: CandidateWebCallPayload,
    options?: SecondParameter<typeof axiosInstance<CandidateWebCallResponse>>
  ) => {
    return axiosInstance<CandidateWebCallResponse>(
      {
        url: `/candidate_web_call`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: candidateWebCallPayload,
      },
      options
    );
  };
  /**
   * @summary Check Web Link
   */
  const callCheckWebLink = (
    candidateWebCallPayload: CandidateWebCallPayload,
    options?: SecondParameter<typeof axiosInstance<CheckWebLinkResponse>>
  ) => {
    return axiosInstance<CheckWebLinkResponse>(
      {
        url: `/check_web_link`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: candidateWebCallPayload,
      },
      options
    );
  };
  /**
 * Dispatch the owed LiveKit agent for a web call when the candidate joins.

Called eagerly by the UI at Begin-click (in parallel with room.connect) so the
agent is summoned only once the candidate commits, rather than pre-dispatched
during precall. The LiveKit room webhook is an idempotent backstop. A failed
dispatch propagates as 500 so the UI retry (and the backstop) can recover.
 * @summary Dispatch Web Agent
 */
  const callDispatchWebAgent = (
    callId: string,
    options?: SecondParameter<typeof axiosInstance<WebAgentDispatchResponse>>
  ) => {
    return axiosInstance<WebAgentDispatchResponse>(
      { url: `/web_call/${callId}/dispatch-agent`, method: 'POST' },
      options
    );
  };
  /**
 * Persist the candidate's web-call language pick to CandidateCampaignInfo.

Resolves the candidate from either an encoded web-call link id (individual or
shared) or an active call_id, then writes `preferred_language` so subsequent
follow-up SMS / email / interview agents resolve to the candidate's chosen
language. Last-write-wins; no source tracking. Closes the "first contact"
gap from the i18n audit.
 * @summary Set Web Call Language Preference
 */
  const callSetWebCallLanguagePreference = (
    webCallLanguagePreferencePayload: WebCallLanguagePreferencePayload,
    options?: SecondParameter<
      typeof axiosInstance<WebCallLanguagePreferenceResponse>
    >
  ) => {
    return axiosInstance<WebCallLanguagePreferenceResponse>(
      {
        url: `/web_call/language-preference`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: webCallLanguagePreferencePayload,
      },
      options
    );
  };
  /**
 * Record a single funnel step for a candidate's progress through the web call interview flow.
Candidate-facing. Always returns ok=True to avoid blocking the UX, except that a candidate
capability for another call is refused.
 * @summary Record Web Call Funnel Event
 */
  const callRecordWebCallFunnelEvent = (
    webCallFunnelEventPayload: WebCallFunnelEventPayload,
    options?: SecondParameter<typeof axiosInstance<WebCallFunnelEventResponse>>
  ) => {
    return axiosInstance<WebCallFunnelEventResponse>(
      {
        url: `/web_call/funnel_event`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: webCallFunnelEventPayload,
      },
      options
    );
  };
  /**
 * Generate a short-lived LiveKit token for pre-call connection quality testing.

Returns a token for a throwaway room with minimal permissions (publish only,
no subscribe). No agent joins — LiveKit auto-creates the room on connect and
cleans it up after the token expires. Used by the candidate pre-call screen
to measure WebRTC connectivity and latency before the interview starts.
 * @summary Get Preflight Token
 */
  const callGetPreflightToken = (
    options?: SecondParameter<typeof axiosInstance<PreflightTokenResponse>>
  ) => {
    return axiosInstance<PreflightTokenResponse>(
      { url: `/web_call/preflight-token`, method: 'POST' },
      options
    );
  };
  /**
   * @summary Get Campaign Settings For Web Call
   */
  const callGetCampaignSettingsForWebCall = (
    campaignId: string,
    params?: CallGetCampaignSettingsForWebCallParams,
    options?: SecondParameter<typeof axiosInstance<WebCallSettingsResponse>>
  ) => {
    return axiosInstance<WebCallSettingsResponse>(
      {
        url: `/web_call/${campaignId}/campaign_settings_for_web_call`,
        method: 'GET',
        params,
      },
      options
    );
  };
  /**
   * @summary Request New Interview From Deleted Link
   */
  const callRequestNewInterviewFromDeletedLink = (
    deletedLinkNewInterviewRequestPayload: DeletedLinkNewInterviewRequestPayload,
    options?: SecondParameter<
      typeof axiosInstance<DeletedLinkNewInterviewRequestResponse>
    >
  ) => {
    return axiosInstance<DeletedLinkNewInterviewRequestResponse>(
      {
        url: `/web_call/request_new_interview_from_deleted_link`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: deletedLinkNewInterviewRequestPayload,
      },
      options
    );
  };
  /**
 * Trigger an alert email when a candidate hits a critical error during a web interview.

Actionable error types: `server_error` (generic /web-interview/error page),
`connection_failed` (WebRTC call could not connect after all retries),
`connection_problem` (candidate-flow API request never got a response after
all retries — network drop or hung connection; the page offers a retry).
All other types are silently ignored.
 * @summary Web Interview Error Alert
 */
  const callWebInterviewErrorAlert = (
    webInterviewErrorAlertPayload: WebInterviewErrorAlertPayload,
    options?: SecondParameter<
      typeof axiosInstance<WebInterviewErrorAlertResponse>
    >
  ) => {
    return axiosInstance<WebInterviewErrorAlertResponse>(
      {
        url: `/web_interview/error_alert`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: webInterviewErrorAlertPayload,
      },
      options
    );
  };
  /**
 * Submit an opt-out request for a candidate (for individual links).

Lands in Opted Out (HUMAN_REVIEW_REQUESTED): recruiter email, ATS AI Opt
Out Stage, AI-consent flip. Does not revoke SMS.
 * @summary Submit Opt Out Request
 */
  const callSubmitOptOutRequest = (
    optOutRequestPayload: OptOutRequestPayload,
    options?: SecondParameter<typeof axiosInstance<OptOutRequestResponse>>
  ) => {
    return axiosInstance<OptOutRequestResponse>(
      {
        url: `/opt-out-request`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: optOutRequestPayload,
      },
      options
    );
  };
  /**
 * Submit an accommodation request for a candidate.

Two authentication modes:
- Individual link: encodedId header present -> decode to get call/candidate context
- Shared link: call_id + campaign_id in body -> validate call exists and belongs to campaign
 * @summary Submit Accommodation Request
 */
  const callSubmitAccommodationRequest = (
    accommodationRequestPayload: AccommodationRequestPayload,
    options?: SecondParameter<
      typeof axiosInstance<AccommodationRequestResponse>
    >
  ) => {
    return axiosInstance<AccommodationRequestResponse>(
      {
        url: `/accommodation-request`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: accommodationRequestPayload,
      },
      options
    );
  };
  /**
   * @summary Get Campaign Links
   */
  const callGetCampaignLinks = (
    params: CallGetCampaignLinksParams,
    options?: SecondParameter<
      typeof axiosInstance<GenerateCampaignLinkResponse>
    >
  ) => {
    return axiosInstance<GenerateCampaignLinkResponse>(
      { url: `/generate_campaign_link`, method: 'GET', params },
      options
    );
  };
  /**
   * @summary Generate Campaign Link
   */
  const callGenerateCampaignLink = (
    campaignLinkRequest: CampaignLinkRequest,
    options?: SecondParameter<
      typeof axiosInstance<GenerateCampaignLinkResponse>
    >
  ) => {
    return axiosInstance<GenerateCampaignLinkResponse>(
      {
        url: `/generate_campaign_link`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: campaignLinkRequest,
      },
      options
    );
  };
  /**
   * @summary Generate Preapply Opt Out Link
   */
  const callGeneratePreapplyOptOutLink = (
    options?: SecondParameter<
      typeof axiosInstance<GeneratePreapplyOptOutLinkResponse>
    >
  ) => {
    return axiosInstance<GeneratePreapplyOptOutLinkResponse>(
      { url: `/generate_preapply_opt_out_link`, method: 'POST' },
      options
    );
  };
  /**
   * @summary Submit Preapply Opt Out
   */
  const callSubmitPreapplyOptOut = (
    token: string,
    preapplyOptOutPayload: PreapplyOptOutPayload,
    options?: SecondParameter<
      typeof axiosInstance<SubmitPreapplyOptOutResponse>
    >
  ) => {
    return axiosInstance<SubmitPreapplyOptOutResponse>(
      {
        url: `/candidate/preapply-opt-out/${token}/submit`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: preapplyOptOutPayload,
      },
      options
    );
  };
  /**
   * @summary Get Preapply Opt Out Page Data
   */
  const callGetPreapplyOptOutPageData = (
    token: string,
    options?: SecondParameter<
      typeof axiosInstance<PreapplyOptOutPageDataResponse>
    >
  ) => {
    return axiosInstance<PreapplyOptOutPageDataResponse>(
      { url: `/candidate/preapply-opt-out/${token}`, method: 'GET' },
      options
    );
  };
  /**
   * Final validation to allow call intiation
   * @summary Validate Encoded Id Plus Candidate
   */
  const callValidateEncodedIdPlusCandidate = (
    candidateWebCallPayload: CandidateWebCallPayload,
    options?: SecondParameter<typeof axiosInstance<ValidateEncodedIdResponse>>
  ) => {
    return axiosInstance<ValidateEncodedIdResponse>(
      {
        url: `/validate_encoded_id_plus_candidate`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: candidateWebCallPayload,
      },
      options
    );
  };
  /**
   * @summary Initiate Send Web Invite Email
   */
  const callInitiateSendWebInviteEmail = (
    sendEmailInvitePayload: SendEmailInvitePayload,
    options?: SecondParameter<typeof axiosInstance<SendWebInviteEmailResponse>>
  ) => {
    return axiosInstance<SendWebInviteEmailResponse>(
      {
        url: `/internal/send_web_invite_email`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: sendEmailInvitePayload,
      },
      options
    );
  };
  /**
 * Generate a practice interview URL that links to a practice campaign.
Returns the full URL that can be opened in a new tab.
 * @summary Get Practice Interview Url
 */
  const callGetPracticeInterviewUrl = (
    practiceInterviewUrlPayload: PracticeInterviewUrlPayload,
    options?: SecondParameter<
      typeof axiosInstance<PracticeInterviewUrlResponse>
    >
  ) => {
    return axiosInstance<PracticeInterviewUrlResponse>(
      {
        url: `/get_practice_interview_url`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: practiceInterviewUrlPayload,
      },
      options
    );
  };
  /**
   * Exchange an issued invitation for a revocable interview session.
   * @summary Create Candidate Capability
   */
  const callCreateCandidateCapability = (
    candidateCapabilityRequest: CandidateCapabilityRequest,
    options?: SecondParameter<typeof axiosInstance<CandidateCapabilityResponse>>
  ) => {
    return axiosInstance<CandidateCapabilityResponse>(
      {
        url: `/candidate_capability`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: candidateCapabilityRequest,
      },
      options
    );
  };
  /**
   * @summary Exchange Interview Launch
   */
  const callExchangeInterviewLaunch = (
    interviewLaunchExchangeRequest: InterviewLaunchExchangeRequest,
    options?: SecondParameter<typeof axiosInstance<InterviewSessionResponse>>
  ) => {
    return axiosInstance<InterviewSessionResponse>(
      {
        url: `/interview_sessions/launch/exchange`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: interviewLaunchExchangeRequest,
      },
      options
    );
  };
  /**
   * @summary Refresh Interview Session
   */
  const callRefreshInterviewSession = (
    interviewSessionRefreshRequest: InterviewSessionRefreshRequest,
    options?: SecondParameter<typeof axiosInstance<InterviewSessionResponse>>
  ) => {
    return axiosInstance<InterviewSessionResponse>(
      {
        url: `/interview_sessions/refresh`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: interviewSessionRefreshRequest,
      },
      options
    );
  };
  /**
   * @summary Get Interview Session
   */
  const callGetInterviewSession = (
    sessionId: string,
    options?: SecondParameter<typeof axiosInstance<InterviewSessionBootstrap>>
  ) => {
    return axiosInstance<InterviewSessionBootstrap>(
      { url: `/interview_sessions/${sessionId}`, method: 'GET' },
      options
    );
  };
  /**
   * @summary Create Staff Test Session
   */
  const callCreateStaffTestSession = (
    staffTestSessionPayload: StaffTestSessionPayload,
    options?: SecondParameter<typeof axiosInstance<InterviewLaunchResponse>>
  ) => {
    return axiosInstance<InterviewLaunchResponse>(
      {
        url: `/interview_sessions/staff_test`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: staffTestSessionPayload,
      },
      options
    );
  };
  /**
   * @summary Create Interview Draft
   */
  const callCreateInterviewDraft = (
    createInterviewDraftRequest: CreateInterviewDraftRequest,
    options?: SecondParameter<typeof axiosInstance<InterviewDraftResponse>>
  ) => {
    return axiosInstance<InterviewDraftResponse>(
      {
        url: `/interview_sessions/drafts`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createInterviewDraftRequest,
      },
      options
    );
  };
  /**
   * Accept the draft by the contacts the applicant entered; public links send no code.
   * @summary Accept Unverified Interview Draft
   */
  const callAcceptUnverifiedInterviewDraft = (
    draftId: string,
    options?: SecondParameter<
      typeof axiosInstance<VerifyInterviewContactResponse>
    >
  ) => {
    return axiosInstance<VerifyInterviewContactResponse>(
      {
        url: `/interview_sessions/drafts/${draftId}/accept_unverified`,
        method: 'POST',
      },
      options
    );
  };
  /**
   * @summary Complete Interview Draft
   */
  const callCompleteInterviewDraft = (
    draftId: string,
    completeInterviewDraftRequest: CompleteInterviewDraftRequest,
    options?: SecondParameter<typeof axiosInstance<InterviewSessionResponse>>
  ) => {
    return axiosInstance<InterviewSessionResponse>(
      {
        url: `/interview_sessions/drafts/${draftId}/complete`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: completeInterviewDraftRequest,
      },
      options
    );
  };
  /**
   * @summary Submit Verified Interview Draft
   */
  const callSubmitVerifiedInterviewDraft = (
    draftId: string,
    bodyCallSubmitVerifiedInterviewDraft: BodyCallSubmitVerifiedInterviewDraft,
    options?: SecondParameter<
      typeof axiosInstance<SubmitVerifiedInterviewDraftResponse>
    >
  ) => {
    const formData = new FormData();
    formData.append(
      `idempotency_key`,
      bodyCallSubmitVerifiedInterviewDraft.idempotency_key
    );
    if (bodyCallSubmitVerifiedInterviewDraft.questions !== undefined) {
      formData.append(
        `questions`,
        bodyCallSubmitVerifiedInterviewDraft.questions
      );
    }
    if (
      bodyCallSubmitVerifiedInterviewDraft.resume_file !== undefined &&
      bodyCallSubmitVerifiedInterviewDraft.resume_file !== null
    ) {
      formData.append(
        `resume_file`,
        bodyCallSubmitVerifiedInterviewDraft.resume_file
      );
    }
    if (
      bodyCallSubmitVerifiedInterviewDraft.opt_out_of_ai_pre_screen !==
      undefined
    ) {
      formData.append(
        `opt_out_of_ai_pre_screen`,
        bodyCallSubmitVerifiedInterviewDraft.opt_out_of_ai_pre_screen.toString()
      );
    }
    if (
      bodyCallSubmitVerifiedInterviewDraft.accommodation_request_text !==
        undefined &&
      bodyCallSubmitVerifiedInterviewDraft.accommodation_request_text !== null
    ) {
      formData.append(
        `accommodation_request_text`,
        bodyCallSubmitVerifiedInterviewDraft.accommodation_request_text
      );
    }

    return axiosInstance<SubmitVerifiedInterviewDraftResponse>(
      {
        url: `/interview_sessions/drafts/${draftId}/submission`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
      },
      options
    );
  };
  /**
 * Public endpoint for initiating a test call.
Creates the campaign and call db objects. Then initiates the call.

If use_intake_flow is True, initiates a candidate intake call flow
(collects name/email before interview, like permanent number campaigns).
Otherwise, initiates a standard interview call.

Returns the call_id and campaign_id.
 * @summary Test Call
 */
  const callTestCall = (
    testCallPayload: TestCallPayload,
    options?: SecondParameter<typeof axiosInstance<TestCallResponse>>
  ) => {
    return axiosInstance<TestCallResponse>(
      {
        url: `/test_call`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: testCallPayload,
      },
      options
    );
  };
  /**
   * Initiate a test call.
   * @summary Initiate Test Web Call
   */
  const callInitiateTestWebCall = (
    initiateTestWebCallPayload: InitiateTestWebCallPayload,
    options?: SecondParameter<typeof axiosInstance<WebCallInitiatedResponse>>
  ) => {
    return axiosInstance<WebCallInitiatedResponse>(
      {
        url: `/initiate_test_web_call`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: initiateTestWebCallPayload,
      },
      options
    );
  };
  /**
 * Endpoint for initiating a practice call.
Creates the campaign and call db objects. Then initiates the call.
Returns the call_id and campaign_id.
 * @summary Initiate Practice Web Call
 */
  const callInitiatePracticeWebCall = (
    initiateTestWebCallPayload: InitiateTestWebCallPayload,
    options?: SecondParameter<typeof axiosInstance<WebCallInitiatedResponse>>
  ) => {
    return axiosInstance<WebCallInitiatedResponse>(
      {
        url: `/initiate_practice_web_call`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: initiateTestWebCallPayload,
      },
      options
    );
  };
  /**
   * The browser-authored setup format has been replaced by staff/session launches.
   * @summary Get And Create Test Call Candidate Info
   */
  const callGetAndCreateTestCallCandidateInfo = (
    bodyCallGetAndCreateTestCallCandidateInfo: BodyCallGetAndCreateTestCallCandidateInfo,
    options?: SecondParameter<typeof axiosInstance<CallCreatedResponse>>
  ) => {
    const formData = new FormData();
    formData.append(
      `candidate_name`,
      bodyCallGetAndCreateTestCallCandidateInfo.candidate_name
    );
    formData.append(
      `campaign_id`,
      bodyCallGetAndCreateTestCallCandidateInfo.campaign_id
    );
    formData.append(
      `voice_name`,
      bodyCallGetAndCreateTestCallCandidateInfo.voice_name
    );
    formData.append(
      `default_id`,
      bodyCallGetAndCreateTestCallCandidateInfo.default_id
    );
    if (
      bodyCallGetAndCreateTestCallCandidateInfo.candidate_timezone !== undefined
    ) {
      formData.append(
        `candidate_timezone`,
        bodyCallGetAndCreateTestCallCandidateInfo.candidate_timezone
      );
    }
    if (
      bodyCallGetAndCreateTestCallCandidateInfo.candidate_email !== undefined
    ) {
      formData.append(
        `candidate_email`,
        bodyCallGetAndCreateTestCallCandidateInfo.candidate_email
      );
    }
    if (
      bodyCallGetAndCreateTestCallCandidateInfo.candidate_phone !== undefined
    ) {
      formData.append(
        `candidate_phone`,
        bodyCallGetAndCreateTestCallCandidateInfo.candidate_phone
      );
    }
    if (
      bodyCallGetAndCreateTestCallCandidateInfo.candidate_source !==
        undefined &&
      bodyCallGetAndCreateTestCallCandidateInfo.candidate_source !== null
    ) {
      formData.append(
        `candidate_source`,
        bodyCallGetAndCreateTestCallCandidateInfo.candidate_source
      );
    }
    if (
      bodyCallGetAndCreateTestCallCandidateInfo.resume_file !== undefined &&
      bodyCallGetAndCreateTestCallCandidateInfo.resume_file !== null
    ) {
      formData.append(
        `resume_file`,
        bodyCallGetAndCreateTestCallCandidateInfo.resume_file
      );
    }
    if (
      bodyCallGetAndCreateTestCallCandidateInfo.original_interview_campaign_id !==
        undefined &&
      bodyCallGetAndCreateTestCallCandidateInfo.original_interview_campaign_id !==
        null
    ) {
      formData.append(
        `original_interview_campaign_id`,
        bodyCallGetAndCreateTestCallCandidateInfo.original_interview_campaign_id
      );
    }

    return axiosInstance<CallCreatedResponse>(
      {
        url: `/get_and_create_test_call_candidate_info`,
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: formData,
      },
      options
    );
  };
  /**
   * Sends email to candidate with test link.
   * @summary Send Web Call Test Email
   */
  const callSendWebCallTestEmail = (
    webCallEmailPayload: WebCallEmailPayload,
    options?: SecondParameter<
      typeof axiosInstance<SendWebCallTestEmailResponse>
    >
  ) => {
    return axiosInstance<SendWebCallTestEmailResponse>(
      {
        url: `/send_web_call_test_email`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: webCallEmailPayload,
      },
      options
    );
  };
  /**
 * Sends a test initial email using content provided by the frontend.

Requires a valid campaign_id owned by the caller's org to prevent abuse.
 * @summary Send Test Initial Email
 */
  const callSendTestInitialEmail = (
    initialEmailTestPayload: InitialEmailTestPayload,
    options?: SecondParameter<
      typeof axiosInstance<SendTestInitialEmailResponse>
    >
  ) => {
    return axiosInstance<SendTestInitialEmailResponse>(
      {
        url: `/send_test_initial_email`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: initialEmailTestPayload,
      },
      options
    );
  };
  /**
 * Dev tool endpoint to simulate SMS during candidate intake call.
Broadcasts an SMS event to the intake call's Redis channel for testing.

This bypasses the actual Twilio SMS webhook and directly broadcasts
the event, allowing for easier testing of SMS fallback functionality.
 * @summary Simulate Intake Sms
 */
  const callSimulateIntakeSms = (
    simulateSMSPayload: SimulateSMSPayload,
    options?: SecondParameter<typeof axiosInstance<SimulateIntakeSmsResponse>>
  ) => {
    return axiosInstance<SimulateIntakeSmsResponse>(
      {
        url: `/dev/simulate_intake_sms`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: simulateSMSPayload,
      },
      options
    );
  };
  /**
 * Endpoint to set sentinel file indicating that all video chunks have been uploaded.

:param call_id: The call ID associated with the recording.
 * @summary Finalize Web Call Recording
 */
  const callFinalizeWebCallRecording = (
    bodyCallFinalizeWebCallRecording: BodyCallFinalizeWebCallRecording,
    options?: SecondParameter<typeof axiosInstance<FinalizeRecordingResponse>>
  ) => {
    const formUrlEncoded = new URLSearchParams();
    formUrlEncoded.append(`call_id`, bodyCallFinalizeWebCallRecording.call_id);

    return axiosInstance<FinalizeRecordingResponse>(
      {
        url: `/finalize_web_call_recording`,
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        data: formUrlEncoded,
      },
      options
    );
  };
  /**
 * Check whether a specific web call is a finished interview and whether post-processing
is done.

Used by the candidate-facing feedback pages to gate the "Return to Interview" banner:
- While processing_complete=False, show a "please wait" message (no restart button).
- Once processing_complete=True and completed=False, show the restart button.
Uses call_id directly so it works uniformly for both individual and shared links.
No auth required.
 * @summary Get Call Completion Status
 */
  const callGetCallCompletionStatus = (
    callId: string,
    options?: SecondParameter<
      typeof axiosInstance<CallCompletionStatusResponse>
    >
  ) => {
    return axiosInstance<CallCompletionStatusResponse>(
      { url: `/web_call/call_completion_status/${callId}`, method: 'GET' },
      options
    );
  };
  /**
 * Admin endpoint to retrieve the unredacted transcript for a call.
Only accessible to users with the Admin role (or full-access support users).
 * @summary Get Unredacted Transcript
 */
  const callGetUnredactedTranscript = (
    callId: string,
    options?: SecondParameter<
      typeof axiosInstance<UnredactedTranscriptResponse>
    >
  ) => {
    return axiosInstance<UnredactedTranscriptResponse>(
      { url: `/admin/call/${callId}/unredacted_transcript`, method: 'GET' },
      options
    );
  };
  /**
 * Endpoint to log a cheating event for a web call.

Events are persisted when the event interval [start_ts, end_ts] overlaps the
screening window [L, U]. L = max(30s, T) once screening started at elapsed T
(Redis key); when the key is absent or Redis fails, L fails open to 30s.
U is the elapsed seconds when screen_complete was set (Redis key); when
unavailable, window is [L, +inf).

Redis pub/sub notifications (camera off, screen share, etc.) are sent whenever the
client posts an event, independent of Cosmos persistence.
 * @summary Log Cheating Event
 */
  const callLogCheatingEvent = (
    callId: string,
    logCheatingEventPayload: LogCheatingEventPayload,
    options?: SecondParameter<typeof axiosInstance<LogCheatingEventResponse>>
  ) => {
    return axiosInstance<LogCheatingEventResponse>(
      {
        url: `/web_call/${callId}/log_cheating_event`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: logCheatingEventPayload,
      },
      options
    );
  };
  /**
   * Capture a frame during a face event or screen share event for real-time processing
   * @summary Capture Frame
   */
  const callCaptureFrame = (
    callId: string,
    captureFramePayload: CaptureFramePayload,
    options?: SecondParameter<typeof axiosInstance<CaptureFrameResponse>>
  ) => {
    return axiosInstance<CaptureFrameResponse>(
      {
        url: `/web_call/${callId}/capture_frame`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: captureFramePayload,
      },
      options
    );
  };
  /**
 * Endpoint to notify that the camera has been restored (turned back on).
This is not a cheating event, just a notification for AI to stop asking about camera.
 * @summary Camera Restored
 */
  const callCameraRestored = (
    callId: string,
    options?: SecondParameter<typeof axiosInstance<CameraRestoredResponse>>
  ) => {
    return axiosInstance<CameraRestoredResponse>(
      { url: `/web_call/${callId}/camera_restored`, method: 'POST' },
      options
    );
  };
  /**
 * Endpoint to notify that screen sharing has been restored.
This is not a cheating event, just a notification for AI to stop asking about screen sharing.
 * @summary Screen Share Restored
 */
  const callScreenShareRestored = (
    callId: string,
    options?: SecondParameter<typeof axiosInstance<ScreenShareRestoredResponse>>
  ) => {
    return axiosInstance<ScreenShareRestoredResponse>(
      { url: `/web_call/${callId}/screen_share_restored`, method: 'POST' },
      options
    );
  };
  /**
 * Endpoint to notify that multiple displays have been removed (back to single display).
This is not a cheating event, just a notification for AI to stop asking about multiple displays.
 * @summary Multiple Displays Removed
 */
  const callMultipleDisplaysRemoved = (
    callId: string,
    options?: SecondParameter<
      typeof axiosInstance<MultipleDisplaysRemovedResponse>
    >
  ) => {
    return axiosInstance<MultipleDisplaysRemovedResponse>(
      { url: `/web_call/${callId}/multiple_displays_removed`, method: 'POST' },
      options
    );
  };
  /**
 * Opt a candidate out of AI interviews from an active web call.

Lands in Opted Out (HUMAN_REVIEW_REQUESTED): recruiter email, ATS AI Opt
Out Stage, AI-consent flip. Does not revoke SMS.
 * @summary Opt Out Of Active Call
 */
  const callOptOutOfActiveCall = (
    callId: string,
    options?: SecondParameter<typeof axiosInstance<OptOutOfActiveCallResponse>>
  ) => {
    return axiosInstance<OptOutOfActiveCallResponse>(
      { url: `/web_call/${callId}/opt_out`, method: 'POST' },
      options
    );
  };
  /**
 * Get frames captured in real-time during cheating events with cached LLM analysis.

Returns cheating events and frames from ALL sessions (if call is part of a rejoin chain).
Timestamps are adjusted for rejoined calls to maintain continuous timeline across sessions.

Note: Uses cache-first approach with automatic database fallback if cache expired.

Proctoring frames and their analysis are staff review material: a session caller needs a
matching org and VIEW on the job, and only an unrestricted transcript share link is honored
(the submittal report never renders frames). Interview headers are refused in the middleware.

The call is looked up by id across every org, so an unknown id and a refused caller both get
the same coded 404: a 403 would tell a caller from another org (or holding a link for another
candidate) that the call exists. Missing credentials stay a 401.
 * @summary Extract Frames From Cheating Events
 */
  const callExtractFramesFromCheatingEvents = (
    callId: string,
    params?: CallExtractFramesFromCheatingEventsParams,
    options?: SecondParameter<typeof axiosInstance<ExtractFramesResponse>>
  ) => {
    return axiosInstance<ExtractFramesResponse>(
      { url: `/web_call/${callId}/extract_frames`, method: 'GET', params },
      options
    );
  };
  /**
   * Save network quality readings for a web call to Cosmos DB.
   * @summary Save Network History
   */
  const callSaveNetworkHistory = (
    callId: string,
    saveNetworkHistoryPayload: SaveNetworkHistoryPayload,
    options?: SecondParameter<typeof axiosInstance<SaveNetworkHistoryResponse>>
  ) => {
    return axiosInstance<SaveNetworkHistoryResponse>(
      {
        url: `/web_call/${callId}/network_history`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: saveNetworkHistoryPayload,
      },
      options
    );
  };
  /**
 * Get network quality readings and connectivity incidents for a web call,
stitched across all legs of its rejoin chain onto the merged-recording timeline.

Session callers need a matching org and VIEW on the job; transcript and submittal share
links are honored for the candidate, job and call they name.
 * @summary Get Network History
 */
  const callGetNetworkHistory = (
    callId: string,
    options?: SecondParameter<typeof axiosInstance<GetNetworkHistoryResponse>>
  ) => {
    return axiosInstance<GetNetworkHistoryResponse>(
      { url: `/web_call/${callId}/network_history`, method: 'GET' },
      options
    );
  };
  /**
   * Log device telemetry and persist a weak signal for known suspicious virtual tools.
   * @summary Report Media Devices
   */
  const callReportMediaDevices = (
    callId: string,
    reportMediaDevicesPayload: ReportMediaDevicesPayload,
    options?: SecondParameter<typeof axiosInstance<ReportMediaDevicesResponse>>
  ) => {
    return axiosInstance<ReportMediaDevicesResponse>(
      {
        url: `/web_call/${callId}/media_devices`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: reportMediaDevicesPayload,
      },
      options
    );
  };
  /**
   * List available Persona ID verification templates for org/job configuration.
   * @summary List Persona Verification Templates
   */
  const callListPersonaVerificationTemplates = (
    options?: SecondParameter<
      typeof axiosInstance<PersonaVerificationTemplateResponse[]>
    >
  ) => {
    return axiosInstance<PersonaVerificationTemplateResponse[]>(
      { url: `/web_call/persona_verification_templates`, method: 'GET' },
      options
    );
  };
  /**
   * @summary Initiate Persona Verification
   */
  const callInitiatePersonaVerification = (
    initiatePersonaVerificationPayload: InitiatePersonaVerificationPayload,
    options?: SecondParameter<
      typeof axiosInstance<InitiatePersonaVerificationResponse>
    >
  ) => {
    return axiosInstance<InitiatePersonaVerificationResponse>(
      {
        url: `/web_call/initiate_persona_verification`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: initiatePersonaVerificationPayload,
      },
      options
    );
  };
  /**
 * Record the inquiry id once the embedded flow has created it.

Expiry detection reads this id later. An in-progress row keeps the first id it was given.
 * @summary Attach Persona Inquiry
 */
  const callAttachPersonaInquiry = (
    verificationId: string,
    attachPersonaInquiryPayload: AttachPersonaInquiryPayload,
    options?: SecondParameter<
      typeof axiosInstance<AttachPersonaInquiryResponse>
    >
  ) => {
    return axiosInstance<AttachPersonaInquiryResponse>(
      {
        url: `/web_call/${verificationId}/persona_inquiry`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: attachPersonaInquiryPayload,
      },
      options
    );
  };
  /**
 * Whether the stored Persona inquiry has expired.

An expired inquiry's session is expired with it. No stored inquiry means the flow has not
created one yet, which is not an expiry.
 * @summary Get Persona Inquiry Expired
 */
  const callGetPersonaInquiryExpired = (
    verificationId: string,
    options?: SecondParameter<
      typeof axiosInstance<PersonaInquiryExpiredResponse>
    >
  ) => {
    return axiosInstance<PersonaInquiryExpiredResponse>(
      {
        url: `/web_call/${verificationId}/persona_inquiry_expired`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Verify Persona Identity
   */
  const callVerifyPersonaIdentity = (
    verifyPersonaIdentityPayload: VerifyPersonaIdentityPayload,
    options?: SecondParameter<
      typeof axiosInstance<VerifyPersonaIdentityResponse>
    >
  ) => {
    return axiosInstance<VerifyPersonaIdentityResponse>(
      {
        url: `/web_call/verify_persona_identity`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: verifyPersonaIdentityPayload,
      },
      options
    );
  };
  /**
   * Record candidate lifecycle status without granting identity verification.
   * @summary Update Persona Verification Status
   */
  const callUpdatePersonaVerificationStatus = (
    verificationId: string,
    updatePersonaVerificationStatusPayload: UpdatePersonaVerificationStatusPayload,
    options?: SecondParameter<
      typeof axiosInstance<UpdatePersonaVerificationStatusResponse>
    >
  ) => {
    return axiosInstance<UpdatePersonaVerificationStatusResponse>(
      {
        url: `/web_call/${verificationId}/update_status`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: updatePersonaVerificationStatusPayload,
      },
      options
    );
  };
  /**
 * Record a cancelled Persona inquiry and classify how far the candidate got.

Marks the verification CANCELLED and, when an inquiry id is available, inspects the inquiry
to classify the furthest step reached (selfie vs ID vs nothing) and capture a recruiter-
facing failure reason. A Persona/API hiccup must not let an unverified candidate through, so
classification fails closed to NO_UPLOAD (which blocks proceeding).
 * @summary Cancel Persona Verification
 */
  const callCancelPersonaVerification = (
    verificationId: string,
    cancelPersonaVerificationPayload: CancelPersonaVerificationPayload,
    options?: SecondParameter<
      typeof axiosInstance<CancelPersonaVerificationResponse>
    >
  ) => {
    return axiosInstance<CancelPersonaVerificationResponse>(
      {
        url: `/web_call/${verificationId}/cancel_persona_verification`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: cancelPersonaVerificationPayload,
      },
      options
    );
  };
  /**
 * Let a candidate continue after a partially completed (cancelled) verification.

The candidate uploaded an ID but did not finish the flow. We record their explanation and
FLAG the verification so a recruiter reviews it, rather than marking it a clean success. The
flag_reason set by the cancel step (what failed) is preserved.
 * @summary Proceed Partial Verification
 */
  const callProceedPartialVerification = (
    verificationId: string,
    proceedPartialVerificationPayload: ProceedPartialVerificationPayload,
    options?: SecondParameter<
      typeof axiosInstance<ProceedPartialVerificationResponse>
    >
  ) => {
    return axiosInstance<ProceedPartialVerificationResponse>(
      {
        url: `/web_call/${verificationId}/proceed_partial_verification`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: proceedPartialVerificationPayload,
      },
      options
    );
  };
  /**
 * Endpoint to retrieve all Persona verification attempts for a candidate and call.

Attempts carry the candidate's selfie and the names read off their ID document, so this needs
the same org and job VIEW grant as the sibling identity endpoints.
 * @summary Get Persona Verifications
 */
  const callGetPersonaVerifications = (
    callId: string,
    candidateId: string,
    options?: SecondParameter<
      typeof axiosInstance<GetPersonaVerificationsResponse>
    >
  ) => {
    return axiosInstance<GetPersonaVerificationsResponse>(
      {
        url: `/web_call/${callId}/candidate/${candidateId}/persona_verifications`,
        method: 'GET',
      },
      options
    );
  };
  /**
 * Get face match verification sessions for a candidate's call.

Accepts Stytch sessions or unrestricted share-transcript headers (same as
call_details siblings). Interview headers remain blocked in authorize_request.

Sessions carry the candidate's reference photo, so a session caller needs VIEW on the job as
well as a matching org. A share link carries no permissions and is already scoped to this one
candidate, so it skips that check.
 * @summary Get Face Match Sessions
 */
  const callGetFaceMatchSessions = (
    callId: string,
    candidateId: string,
    options?: SecondParameter<
      typeof axiosInstance<GetFaceMatchSessionsResponse>
    >
  ) => {
    return axiosInstance<GetFaceMatchSessionsResponse>(
      {
        url: `/web_call/${callId}/candidate/${candidateId}/face_match_sessions`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * Latest identity verification outcome, gated like the sibling identity endpoints.
   * @summary Get Persona Verification Status
   */
  const callGetPersonaVerificationStatus = (
    callId: string,
    candidateId: string,
    options?: SecondParameter<
      typeof axiosInstance<PersonaVerificationStatusResponse>
    >
  ) => {
    return axiosInstance<PersonaVerificationStatusResponse>(
      {
        url: `/web_call/${callId}/candidate/${candidateId}/persona_verification_status`,
        method: 'GET',
      },
      options
    );
  };
  /**
   * @summary Update Verification Explanation
   */
  const callUpdateVerificationExplanation = (
    verificationId: string,
    verifyPersonaWithExplanationPayload: VerifyPersonaWithExplanationPayload,
    options?: SecondParameter<
      typeof axiosInstance<UpdateVerificationExplanationResponse>
    >
  ) => {
    return axiosInstance<UpdateVerificationExplanationResponse>(
      {
        url: `/web_call/${verificationId}/update_verification_explanation`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: verifyPersonaWithExplanationPayload,
      },
      options
    );
  };
  /**
   * @summary Check Web Audio Recording
   */
  const callCheckWebAudioRecording = (
    callId: string,
    options?: SecondParameter<typeof axiosInstance<AudioRecordingCheckResponse>>
  ) => {
    return axiosInstance<AudioRecordingCheckResponse>(
      { url: `/call/${callId}/check_web_audio_recording`, method: 'GET' },
      options
    );
  };
  /**
   * @summary Check Phone Recording
   */
  const callCheckPhoneRecording = (
    callId: string,
    options?: SecondParameter<typeof axiosInstance<AudioRecordingCheckResponse>>
  ) => {
    return axiosInstance<AudioRecordingCheckResponse>(
      { url: `/call/${callId}/check_phone_recording`, method: 'GET' },
      options
    );
  };
  /**
   * @summary Check Web Recording
   */
  const callCheckWebRecording = (
    callId: string,
    options?: SecondParameter<typeof axiosInstance<WebRecordingCheckResponse>>
  ) => {
    return axiosInstance<WebRecordingCheckResponse>(
      { url: `/call/${callId}/check_web_recording`, method: 'GET' },
      options
    );
  };
  /**
 * Download the interview results PDF for a call.

Uses the same ``create_pdf_summary_from_call`` generator as ATS PDF attachments, with the
built-in labels in the downloading member's display language.
Auth is enforced by the ``^/call/{uuid}`` middleware (VIEW on the call's job).
 * @summary Download Interview Results Pdf
 */
  const callDownloadInterviewResultsPdf = (
    callId: string,
    options?: SecondParameter<typeof axiosInstance<Blob>>
  ) => {
    return axiosInstance<Blob>(
      {
        url: `/call/${callId}/interview-results-pdf`,
        method: 'GET',
        responseType: 'blob',
      },
      options
    );
  };
  /**
 * Replay the last test-call results frame published on this call's status channel.

The `^/call/{uuid}` middleware already enforces VIEW on the call's job; the org check
here mirrors the WebSocket handler for defense in depth. `results_frame` is the verbatim
broadcast JSON so the client keeps a single parse path for both transports.
 * @summary Get Test Call Results
 */
  const callGetTestCallResults = (
    callId: string,
    options?: SecondParameter<typeof axiosInstance<TestCallResultsResponse>>
  ) => {
    return axiosInstance<TestCallResultsResponse>(
      { url: `/call/${callId}/test_call_results`, method: 'GET' },
      options
    );
  };
  return {
    callCreateOrFindExistingCandidateCall,
    callInternalInitiateCall,
    callCandidateWebCall,
    callCheckWebLink,
    callDispatchWebAgent,
    callSetWebCallLanguagePreference,
    callRecordWebCallFunnelEvent,
    callGetPreflightToken,
    callGetCampaignSettingsForWebCall,
    callRequestNewInterviewFromDeletedLink,
    callWebInterviewErrorAlert,
    callSubmitOptOutRequest,
    callSubmitAccommodationRequest,
    callGetCampaignLinks,
    callGenerateCampaignLink,
    callGeneratePreapplyOptOutLink,
    callSubmitPreapplyOptOut,
    callGetPreapplyOptOutPageData,
    callValidateEncodedIdPlusCandidate,
    callInitiateSendWebInviteEmail,
    callGetPracticeInterviewUrl,
    callCreateCandidateCapability,
    callExchangeInterviewLaunch,
    callRefreshInterviewSession,
    callGetInterviewSession,
    callCreateStaffTestSession,
    callCreateInterviewDraft,
    callAcceptUnverifiedInterviewDraft,
    callCompleteInterviewDraft,
    callSubmitVerifiedInterviewDraft,
    callTestCall,
    callInitiateTestWebCall,
    callInitiatePracticeWebCall,
    callGetAndCreateTestCallCandidateInfo,
    callSendWebCallTestEmail,
    callSendTestInitialEmail,
    callSimulateIntakeSms,
    callFinalizeWebCallRecording,
    callGetCallCompletionStatus,
    callGetUnredactedTranscript,
    callLogCheatingEvent,
    callCaptureFrame,
    callCameraRestored,
    callScreenShareRestored,
    callMultipleDisplaysRemoved,
    callOptOutOfActiveCall,
    callExtractFramesFromCheatingEvents,
    callSaveNetworkHistory,
    callGetNetworkHistory,
    callReportMediaDevices,
    callListPersonaVerificationTemplates,
    callInitiatePersonaVerification,
    callAttachPersonaInquiry,
    callGetPersonaInquiryExpired,
    callVerifyPersonaIdentity,
    callUpdatePersonaVerificationStatus,
    callCancelPersonaVerification,
    callProceedPartialVerification,
    callGetPersonaVerifications,
    callGetFaceMatchSessions,
    callGetPersonaVerificationStatus,
    callUpdateVerificationExplanation,
    callCheckWebAudioRecording,
    callCheckPhoneRecording,
    callCheckWebRecording,
    callDownloadInterviewResultsPdf,
    callGetTestCallResults,
  };
};
export type CallCreateOrFindExistingCandidateCallResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCall>['callCreateOrFindExistingCandidateCall']
    >
  >
>;
export type CallInternalInitiateCallResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callInternalInitiateCall']>>
>;
export type CallCandidateWebCallResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callCandidateWebCall']>>
>;
export type CallCheckWebLinkResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callCheckWebLink']>>
>;
export type CallDispatchWebAgentResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callDispatchWebAgent']>>
>;
export type CallSetWebCallLanguagePreferenceResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callSetWebCallLanguagePreference']>
  >
>;
export type CallRecordWebCallFunnelEventResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callRecordWebCallFunnelEvent']>
  >
>;
export type CallGetPreflightTokenResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callGetPreflightToken']>>
>;
export type CallGetCampaignSettingsForWebCallResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callGetCampaignSettingsForWebCall']>
  >
>;
export type CallRequestNewInterviewFromDeletedLinkResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCall>['callRequestNewInterviewFromDeletedLink']
    >
  >
>;
export type CallWebInterviewErrorAlertResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callWebInterviewErrorAlert']>>
>;
export type CallSubmitOptOutRequestResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callSubmitOptOutRequest']>>
>;
export type CallSubmitAccommodationRequestResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callSubmitAccommodationRequest']>
  >
>;
export type CallGetCampaignLinksResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callGetCampaignLinks']>>
>;
export type CallGenerateCampaignLinkResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callGenerateCampaignLink']>>
>;
export type CallGeneratePreapplyOptOutLinkResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callGeneratePreapplyOptOutLink']>
  >
>;
export type CallSubmitPreapplyOptOutResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callSubmitPreapplyOptOut']>>
>;
export type CallGetPreapplyOptOutPageDataResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callGetPreapplyOptOutPageData']>
  >
>;
export type CallValidateEncodedIdPlusCandidateResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callValidateEncodedIdPlusCandidate']>
  >
>;
export type CallInitiateSendWebInviteEmailResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callInitiateSendWebInviteEmail']>
  >
>;
export type CallGetPracticeInterviewUrlResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callGetPracticeInterviewUrl']>>
>;
export type CallCreateCandidateCapabilityResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callCreateCandidateCapability']>
  >
>;
export type CallExchangeInterviewLaunchResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callExchangeInterviewLaunch']>>
>;
export type CallRefreshInterviewSessionResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callRefreshInterviewSession']>>
>;
export type CallGetInterviewSessionResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callGetInterviewSession']>>
>;
export type CallCreateStaffTestSessionResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callCreateStaffTestSession']>>
>;
export type CallCreateInterviewDraftResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callCreateInterviewDraft']>>
>;
export type CallAcceptUnverifiedInterviewDraftResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callAcceptUnverifiedInterviewDraft']>
  >
>;
export type CallCompleteInterviewDraftResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callCompleteInterviewDraft']>>
>;
export type CallSubmitVerifiedInterviewDraftResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callSubmitVerifiedInterviewDraft']>
  >
>;
export type CallTestCallResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callTestCall']>>
>;
export type CallInitiateTestWebCallResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callInitiateTestWebCall']>>
>;
export type CallInitiatePracticeWebCallResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callInitiatePracticeWebCall']>>
>;
export type CallGetAndCreateTestCallCandidateInfoResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCall>['callGetAndCreateTestCallCandidateInfo']
    >
  >
>;
export type CallSendWebCallTestEmailResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callSendWebCallTestEmail']>>
>;
export type CallSendTestInitialEmailResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callSendTestInitialEmail']>>
>;
export type CallSimulateIntakeSmsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callSimulateIntakeSms']>>
>;
export type CallFinalizeWebCallRecordingResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callFinalizeWebCallRecording']>
  >
>;
export type CallGetCallCompletionStatusResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callGetCallCompletionStatus']>>
>;
export type CallGetUnredactedTranscriptResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callGetUnredactedTranscript']>>
>;
export type CallLogCheatingEventResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callLogCheatingEvent']>>
>;
export type CallCaptureFrameResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callCaptureFrame']>>
>;
export type CallCameraRestoredResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callCameraRestored']>>
>;
export type CallScreenShareRestoredResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callScreenShareRestored']>>
>;
export type CallMultipleDisplaysRemovedResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callMultipleDisplaysRemoved']>>
>;
export type CallOptOutOfActiveCallResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callOptOutOfActiveCall']>>
>;
export type CallExtractFramesFromCheatingEventsResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCall>['callExtractFramesFromCheatingEvents']
    >
  >
>;
export type CallSaveNetworkHistoryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callSaveNetworkHistory']>>
>;
export type CallGetNetworkHistoryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callGetNetworkHistory']>>
>;
export type CallReportMediaDevicesResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callReportMediaDevices']>>
>;
export type CallListPersonaVerificationTemplatesResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCall>['callListPersonaVerificationTemplates']
    >
  >
>;
export type CallInitiatePersonaVerificationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callInitiatePersonaVerification']>
  >
>;
export type CallAttachPersonaInquiryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callAttachPersonaInquiry']>>
>;
export type CallGetPersonaInquiryExpiredResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callGetPersonaInquiryExpired']>
  >
>;
export type CallVerifyPersonaIdentityResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callVerifyPersonaIdentity']>>
>;
export type CallUpdatePersonaVerificationStatusResult = NonNullable<
  Awaited<
    ReturnType<
      ReturnType<typeof getCall>['callUpdatePersonaVerificationStatus']
    >
  >
>;
export type CallCancelPersonaVerificationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callCancelPersonaVerification']>
  >
>;
export type CallProceedPartialVerificationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callProceedPartialVerification']>
  >
>;
export type CallGetPersonaVerificationsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callGetPersonaVerifications']>>
>;
export type CallGetFaceMatchSessionsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callGetFaceMatchSessions']>>
>;
export type CallGetPersonaVerificationStatusResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callGetPersonaVerificationStatus']>
  >
>;
export type CallUpdateVerificationExplanationResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callUpdateVerificationExplanation']>
  >
>;
export type CallCheckWebAudioRecordingResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callCheckWebAudioRecording']>>
>;
export type CallCheckPhoneRecordingResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callCheckPhoneRecording']>>
>;
export type CallCheckWebRecordingResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callCheckWebRecording']>>
>;
export type CallDownloadInterviewResultsPdfResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getCall>['callDownloadInterviewResultsPdf']>
  >
>;
export type CallGetTestCallResultsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getCall>['callGetTestCallResults']>>
>;
